var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"foot-tab"}},[_c('router-view'),_c('div',{staticClass:"tab"},[_c('router-link',{staticClass:"home-tab",attrs:{"to":"/home","tag":"span"}}),_c('router-link',{staticClass:"classify-tab",attrs:{"to":"/info","tag":"span"}}),_c('router-link',{staticClass:"mine-tab",attrs:{"to":"/mine","tag":"span"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }